import errors from './errors.js'
import navigation from './navigation.js'
import filters from './filters.js'
import form from './form.js'
import product from './product.js'
import search from './search.js'
import contatti from './contatti.js'
import common from './common.js'

export default {
  errors,
  navigation,
  filters,
  form,
  product,
  search,
  contatti,
  common,
}
